<template>
  <div>
    <Menu />
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Indicadores Previne Brasil"
            description="Atualizar quadrimestralmente esses dados dos Indicadores do Programa Previne Brasil"
            url="/administracao"
            modalDocument="DocIndicadoresPrevineBrasil"
          />
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="">População IBGE</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="População IBGE"
                  v-model="populacaoIbge"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <button class="btn mt-32" v-on:click="salvarPopulacaoIbge()">
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="">Tipologia</label>
                <select
                  class="form-control"
                  @change="onChangeTipologia($event)"
                >
                  <option
                    v-for="(item, index) in array_tipologia"
                    :key="index"
                    v-bind:value="item.id"
                    :selected="tipologia == item.id"
                  >
                    {{ item.descricao }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <button class="btn mt-32" v-on:click="salvarTipologia()">
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 importar-indicadores">
          <div class="row">
            <div class="col-lg-12">
              <hr />
            </div>
            <div class="col-lg-12 importar-indicadores-titulo">
              <h3><i class="icofont-upload-alt"></i> Importar indicador</h3>
              <p>Selecione os arquivos que deseja importar</p>
            </div>
            <div class="col-lg-12">
              <h4>Parâmetro cadastro e resultado atual cadastros</h4>
              <!-- <small>Última importação em 00/00/0000, quadrimestre 2022 Q1</small> -->
              <div class="row">
                <div class="col-lg-10">
                  <div class="file-drop-area">
                    <span class="fake-btn">Escolher arquivo</span>
                    <span class="file-msg">ou arraste aqui o arquivo.xls</span>
                    <input
                      class="file-input"
                      ref="file_resultado_atual_cadastros"
                      type="file"
                      @change="onChangeFileResultadoAtualCadastros()"
                      accept=".xls,application/vnd.ms-excel"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <button @click="importarResultadoAtualCadastros()">
                    <i class="icofont-upload-alt"></i>
                    Importar
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <hr />
            </div>
            <div class="col-lg-12">
              <h4>Consultas pré-natal</h4>
              <!-- <small>Última importação em 00/00/0000, quadrimestre 2022 Q1</small> -->
              <div class="row">
                <div class="col-lg-10">
                  <div class="file-drop-area">
                    <span class="fake-btn">Escolher arquivo</span>
                    <span class="file-msg"
                      >ou arraste aqui o arquivo.xls "Proporção de gestantes com
                      pelo menos 6 (seis) consultas pré-natal"</span
                    >
                    <input
                      class="file-input"
                      ref="file_pre_natal"
                      type="file"
                      @change="onChangeFileIndicador($event, 'preNatal')"
                      accept=".xls,application/vnd.ms-excel"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <button @click="importarIndicador('preNatal')">
                    <i class="icofont-upload-alt"></i>
                    Importar
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <hr />
            </div>
            <div class="col-lg-12">
              <h4>Exames HIV e Sífilis</h4>
              <!-- <small>Última importação em 00/00/0000, quadrimestre 2022 Q1</small> -->
              <div class="row">
                <div class="col-lg-10">
                  <div class="file-drop-area">
                    <span class="fake-btn">Escolher arquivo</span>
                    <span class="file-msg"
                      >ou arraste aqui o arquivo.xls "Proporção de gestantes com
                      realização de exames para sífilis e HIV"</span
                    >
                    <input
                      class="file-input"
                      ref="file_hiv_sifilis"
                      type="file"
                      @change="onChangeFileIndicador($event, 'hivSifilis')"
                      accept=".xls,application/vnd.ms-excel"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <button @click="importarIndicador('hivSifilis')">
                    <i class="icofont-upload-alt"></i>
                    Importar
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <hr />
            </div>
            <div class="col-lg-12">
              <h4>Consultas odontológicas</h4>
              <!-- <small>Última importação em 00/00/0000, quadrimestre 2022 Q1</small> -->
              <div class="row">
                <div class="col-lg-10">
                  <div class="file-drop-area">
                    <span class="fake-btn">Escolher arquivo</span>
                    <span class="file-msg"
                      >ou arraste aqui o arquivo.xls "Proporção de gestantes com
                      atendimento odontológico realizado"</span
                    >
                    <input
                      class="file-input"
                      ref="file_odontologicos"
                      type="file"
                      @change="onChangeFileIndicador($event, 'odontologicos')"
                      accept=".xls,application/vnd.ms-excel"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <button @click="importarIndicador('odontologicos')">
                    <i class="icofont-upload-alt"></i>
                    Importar
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <hr />
            </div>
            <div class="col-lg-12">
              <h4>Indicador citopatológico</h4>
              <!-- <small>Última importação em 00/00/0000, quadrimestre 2022 Q1</small> -->
              <div class="row">
                <div class="col-lg-10">
                  <div class="file-drop-area">
                    <span class="fake-btn">Escolher arquivo</span>
                    <span class="file-msg"
                      >ou arraste aqui o arquivo.xls "Cobertura de exame
                      citopatológico"</span
                    >
                    <input
                      class="file-input"
                      ref="file_citologico"
                      type="file"
                      @change="onChangeFileIndicador($event, 'citologico')"
                      accept=".xls,application/vnd.ms-excel"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <button @click="importarIndicador('citologico')">
                    <i class="icofont-upload-alt"></i>
                    Importar
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <hr />
            </div>
            <div class="col-lg-12">
              <h4>Vacinas polio e penta</h4>
              <!-- <small>Última importação em 00/00/0000, quadrimestre 2022 Q1</small> -->
              <div class="row">
                <div class="col-lg-10">
                  <div class="file-drop-area">
                    <span class="fake-btn">Escolher arquivo</span>
                    <span class="file-msg">ou arraste aqui o arquivo</span>
                    <input
                      class="file-input"
                      ref="file_vacinas_polio_penta"
                      type="file"
                      @change="
                        onChangeFileIndicador($event, 'vacinasPolioPenta')
                      "
                      accept=".xls,application/vnd.ms-excel"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <button @click="importarIndicador('vacinasPolioPenta')">
                    <i class="icofont-upload-alt"></i>
                    Importar
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <hr />
            </div>
            <div class="col-lg-12">
              <h4>Atendimento hipertensão</h4>
              <!-- <small>Última importação em 00/00/0000, quadrimestre 2022 Q1</small> -->
              <div class="row">
                <div class="col-lg-10">
                  <div class="file-drop-area">
                    <span class="fake-btn">Escolher arquivo</span>
                    <span class="file-msg"
                      >ou arraste aqui o arquivo.xls "Percentual de pessoas
                      hipertensas com Pressão Arterial"</span
                    >
                    <input
                      class="file-input"
                      ref="file_hipertensao"
                      type="file"
                      @change="onChangeFileIndicador($event, 'hipertensao')"
                      accept=".xls,application/vnd.ms-excel"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <button @click="importarIndicador('hipertensao')">
                    <i class="icofont-upload-alt"></i>
                    Importar
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <hr />
            </div>
            <div class="col-lg-12">
              <h4>Atendimento diabetes</h4>
              <!-- <small>Última importação em 00/00/0000, quadrimestre 2022 Q1</small> -->
              <div class="row">
                <div class="col-lg-10">
                  <div class="file-drop-area">
                    <span class="fake-btn">Escolher arquivo</span>
                    <span class="file-msg"
                      >ou arraste aqui o arquivo.xls "Percentual de diabéticos
                      com solicitação de hemoglobina glicada"</span
                    >
                    <input
                      class="file-input"
                      ref="file_diabetes"
                      type="file"
                      @change="onChangeFileIndicador($event, 'diabetes')"
                      accept=".xls,application/vnd.ms-excel"
                    />
                  </div>
                </div>
                <div class="col-lg-2">
                  <button @click="importarIndicador('diabetes')">
                    <i class="icofont-upload-alt"></i>
                    Importar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { mapState } from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'IndicadoresPrevineBrasil',
  components: {
    Menu,
    Footer,
    PulseLoader,
    SectionTitle,
  },
  data() {
    return {
      title_page:
        'Atualizar quadrimestralmente esses dados dos Indicadores do Programa Previne Brasil',
      cod_ibge: '',
      equipes: [],
      page: 1,
      perPage: 10,
      pages: [],
      populacaoIbge: '',
      status: {
        error: false,
        message: '',
      },
      loading: false,
      size: '40px',
      color: '#0D98BB',
      array_tipologia: [],
      tipologia: '',
      arquivo_resultado_atual_cadastros: '',
      arquivo_citologico: '',
      arquivo_vacinas_polio_penta: '',
      arquivo_pre_natal: '',
      arquivo_odontologicos: '',
      arquivo_hiv_sifilis: '',
      arquivo_diabetes: '',
      arquivo_hipertensao: '',
      total_equipes: 0,
    }
  },
  computed: {
    displayedEquipes() {
      this.total_equipes = this.equipes.length
      return this.paginate(this.equipes)
    },
  },
  watch: {
    equipes() {
      this.setPages()
    },
  },
  methods: {
    onChangeFileResultadoAtualCadastros() {
      let fileCont = event.target.files.length
      // se tiver um arquivo selecionado adiciona a classe CSS na div pai para ficar com as bordas escuras
      if (fileCont == 1) {
        let divPai = event.target.parentElement
        divPai.classList.add('active-file')
      }
      let fileName = event.target.value.split('\\').pop()
      let prev = event.target.previousElementSibling
      prev.textContent = fileName
      this.arquivo_resultado_atual_cadastros =
        this.$refs.file_resultado_atual_cadastros.files[0]
    },

    importarResultadoAtualCadastros() {
      const file = this.arquivo_resultado_atual_cadastros

      // Verificar se o arquivo foi selecionado
      if (!file) {
        this.$toast.error('Selecione um arquivo antes de importar.', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      // Validar extensão .xls
      const isXlsExt = /\.xls$/i.test(file.name)
      if (!isXlsExt) {
        this.$toast.error('Formato inválido. Envie um arquivo .xls.', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      // Validar MIME quando disponível
      const allowedMimes = [
        'application/vnd.ms-excel',
        'application/xls',
        'application/vnd.ms-office',
        'application/octet-stream', // alguns ambientes/navegadores
        '', // alguns navegadores deixam vazio
      ]
      if (file.type && !allowedMimes.includes(file.type)) {
        this.$toast.error(
          `Tipo de arquivo não reconhecido para .xls (${file.type}).`,
          'Erro:',
          {
            position: 'topRight',
          }
        )
        return
      }

      this.$toast.info('Aguarde! Importando arquivo.', 'Info:', {
        position: 'topRight',
      })

      const url =
        '/app/indicadores-previne-brasil/resultado-atual-cadastros/importar/' +
        this.$store.state.cod_ibge

      const formData = new FormData()
      formData.append('total_equipes', this.total_equipes)
      formData.append('populacao_ibge', this.populacaoIbge)
      formData.append('file', file)

      this.$api
        .post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.error === false) {
            this.$toast.success(response.data.message, 'Sucesso:', {
              position: 'topRight',
            })
            // location.reload()
          } else {
            this.$toast.error(
              response.data.message || 'Falha ao importar.',
              'Erro:',
              {
                position: 'topRight',
              }
            )
          }
        })
        .catch((error) => {
          const status = error?.response?.status
          switch (status) {
            case 500:
              alert(
                'Erro ao importar arquivo! Por favor, entre em contato com o suporte.'
              )
              break
            default:
              this.$toast.error('Falha no upload. Tente novamente.', 'Erro:', {
                position: 'topRight',
              })
              break
          }
        })
    },

    onChangeFileIndicador(event, indicador) {
      let fileCont = event.target.files.length
      // se tiver um arquivo selecionado adiciona a classe CSS na div pai para ficar com as bordas escuras
      if (fileCont == 1) {
        let divPai = event.target.parentElement
        divPai.classList.add('active-file')
      }
      let fileName = event.target.value.split('\\').pop()
      let prev = event.target.previousElementSibling
      prev.textContent = fileName

      switch (indicador) {
        case 'citologico':
          this.arquivo_citologico = this.$refs.file_citologico.files[0]
          break
        case 'vacinasPolioPenta':
          this.arquivo_vacinas_polio_penta =
            this.$refs.file_vacinas_polio_penta.files[0]
          break
        case 'preNatal':
          this.arquivo_pre_natal = this.$refs.file_pre_natal.files[0]
          break
        case 'odontologicos':
          this.arquivo_odontologicos = this.$refs.file_odontologicos.files[0]
          break
        case 'hivSifilis':
          this.arquivo_hiv_sifilis = this.$refs.file_hiv_sifilis.files[0]
          break
        case 'diabetes':
          this.arquivo_diabetes = this.$refs.file_diabetes.files[0]
          break
        case 'hipertensao':
          this.arquivo_hipertensao = this.$refs.file_hipertensao.files[0]
        default:
          break
      }
    },

    importarIndicador(indicador) {
      const rotas = {
        citologico: 'citopatologico',
        vacinasPolioPenta: 'vacinas-polio-penta',
        preNatal: 'pre-natal',
        odontologicos: 'odontologicos',
        hivSifilis: 'hiv-sifilis',
        diabetes: 'diabetes',
        hipertensao: 'hipertensao',
      }

      const arquivos = {
        citologico: this.arquivo_citologico,
        vacinasPolioPenta: this.arquivo_vacinas_polio_penta,
        preNatal: this.arquivo_pre_natal,
        odontologicos: this.arquivo_odontologicos,
        hivSifilis: this.arquivo_hiv_sifilis,
        diabetes: this.arquivo_diabetes,
        hipertensao: this.arquivo_hipertensao,
      }

      // Verifica indicador válido
      if (!rotas[indicador]) {
        this.$toast.error('Indicador inválido.', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      const file = arquivos[indicador]

      // Verificar se o arquivo foi selecionado
      if (!file) {
        this.$toast.error('Selecione um arquivo antes de importar.', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      // Validar extensão .xls
      const isXlsExt = /\.xls$/i.test(file.name)
      if (!isXlsExt) {
        this.$toast.error('Formato inválido. Envie um arquivo .xls', 'Erro:', {
          position: 'topRight',
        })
        return
      }

      // 3) Validar MIME quando disponível (alguns navegadores deixam vazio)
      const allowedMimes = [
        'application/vnd.ms-excel',
        'application/xls',
        'application/vnd.ms-office',
        'application/octet-stream',
        '',
      ]
      if (file.type && !allowedMimes.includes(file.type)) {
        this.$toast.error(
          `Tipo de arquivo não reconhecido para .xls (${file.type}).`,
          'Erro:',
          {
            position: 'topRight',
          }
        )
        return
      }

      this.$toast.info('Aguarde! Importando o arquivo.', 'Info:', {
        position: 'topRight',
      })

      const url =
        '/app/indicadores-previne-brasil/importar-indicador/importar/' +
        this.$store.state.cod_ibge +
        '/' +
        rotas[indicador]

      const formData = new FormData()
      formData.append('file', file)
      formData.append('total_equipes', this.total_equipes)

      this.$api
        .post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.error === false) {
            this.$toast.success(response.data.message, 'Sucesso:', {
              position: 'topRight',
            })
            // location.reload()
          } else {
            this.$toast.error(
              response.data.message || 'Falha ao importar.',
              'Erro:',
              {
                position: 'topRight',
              }
            )
          }
        })
        .catch((error) => {
          const status = error?.response?.status
          switch (status) {
            case 500:
              alert(
                'Erro ao importar arquivo! Por favor, entre em contato com o suporte.'
              )
              break
            default:
              this.$toast.error('Falha no upload. Tente novamente.', 'Erro:', {
                position: 'topRight',
              })
              break
          }
        })
    },

    /**
     * Calcula e define as páginas da listagem.
     */
    setPages() {
      let numberOfPages = Math.ceil(this.equipes.length / this.perPage)
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },

    /**
     * Retorna os registros correspondentes à página atual da paginação.
     *
     * @param {Array} equipes Lista completa de registros
     * @returns {Array} Subconjunto de registros correspondente à página atual
     */
    paginate(equipes) {
      let page = this.page
      let perPage = this.perPage
      let from = page * perPage - perPage
      let to = page * perPage
      return equipes.slice(from, to)
    },

    async carregarEquipes() {
      this.loading = true
      try {
        let response = await this.$api.get(
          '/app/equipes/' + this.$store.state.cod_ibge
        )
        if (response) {
          this.loading = false
          this.equipes = response.data
          this.total_equipes = response.data.length
        }
      } catch (error) {
        this.loading = false
      }
    },

    carregarTipologia() {
      this.$api
        .get(
          '/app/indicadores-previne-brasil/tipologia/' +
            this.$store.state.cod_ibge
        )
        .then((response) => {
          this.array_tipologia = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    onChangeTipologia(event) {
      this.tipologia = event.target.value
    },

    salvarDados(item) {
      this.loading = true
      // let usuario = this.$store.getters.getUser;
      let url =
        '/app/indicadores-previne-brasil/equipe/atualizar/' +
        this.$store.state.cod_ibge
      this.$api
        .post(url, item)
        .then((response) => {
          if (response.data.error == true) {
            this.$toast.error(response.data.message, 'Error:', {
              position: 'topRight',
            })
            this.loading = false
          } else {
            this.$toast.success(response.data.message, 'Sucesso:', {
              position: 'topRight',
            })
            this.loading = false
          }
        })
        .catch(function (error) {
          this.loading = false
          console.log(error)
        })
    },

    buscarPopulacaoIbge() {
      // Busca a população do ibge da cidade
      this.$api
        .get('/app/ultima-atualizacao-dos-dados/' + this.$store.state.cod_ibge)
        .then((response) => {
          this.populacaoIbge = response.data.populacaoIBGE
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    salvarPopulacaoIbge() {
      this.loading = true
      let populacao = {
        populacaoIBGE: this.populacaoIbge,
        cod_ibge: this.$store.state.cod_ibge,
      }
      let url = '/app/atualizar-populacao-ibge/' + this.$store.state.cod_ibge
      this.$api
        .post(url, populacao)
        .then((response) => {
          if (response.data.error == true) {
            this.$toast.error(response.data.message, 'Error:', {
              position: 'topRight',
            })
            this.loading = false
          } else {
            this.$toast.success(response.data.message, 'Sucesso:', {
              position: 'topRight',
            })
            this.loading = false
          }
        })
        .catch(function (error) {
          this.loading = false
          console.log(error)
        })
    },

    buscarTipologia() {
      // Busca a população do ibge da cidade
      this.$api
        .get(
          '/app/indicadores-previne-brasil/tipologia/buscar/' +
            this.$store.state.cod_ibge
        )
        .then((response) => {
          this.tipologia = response.data.tipologia
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    salvarTipologia() {
      this.loading = true
      let item = {
        tipologia: this.tipologia,
      }
      let url =
        '/app/indicadores-previne-brasil/tipologia/salvar/' +
        this.$store.state.cod_ibge
      this.$api
        .post(url, item)
        .then((response) => {
          if (response.data.error == true) {
            this.$toast.error(response.data.message, 'Error:', {
              position: 'topRight',
            })
            this.loading = false
          } else {
            this.$toast.success(response.data.message, 'Sucesso:', {
              position: 'topRight',
            })
            this.loading = false
          }
        })
        .catch(function (error) {
          this.loading = false
          console.log(error)
        })
    },

    init() {
      this.carregarEquipes()
      this.buscarPopulacaoIbge()
      this.buscarTipologia()
      this.carregarTipologia()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
.internal-page label {
  text-transform: uppercase;
  font-weight: 700;
  margin-top: 15px;
}

.table .thead-light th {
  text-align: left;
  vertical-align: middle;
  font-size: 11px;
  line-height: 14px;
}

.table td,
.table th {
  font-size: 13px;
}

.table-indicadores-previne-brasil {
  overflow-x: scroll;
  position: relative;
}

@media (min-width: 992px) {
  .table-indicadores-previne-brasil table thead tr th:nth-child(1),
  .table-indicadores-previne-brasil table tbody tr td:nth-child(1) {
    position: sticky;
    left: 0;
  }

  .table-indicadores-previne-brasil table thead tr th:nth-child(2),
  .table-indicadores-previne-brasil table tbody tr td:nth-child(2) {
    position: sticky;
    left: 70px;
  }

  .table-indicadores-previne-brasil table thead tr th:nth-child(3),
  .table-indicadores-previne-brasil table tbody tr td:nth-child(3) {
    position: sticky;
    left: 151px;
  }

  .table-indicadores-previne-brasil table tbody tr td:nth-child(1),
  .table-indicadores-previne-brasil table tbody tr td:nth-child(2),
  .table-indicadores-previne-brasil table tbody tr td:nth-child(3) {
    background-color: #fff;
  }
}

.importar-indicadores-titulo {
  margin: 10px auto;
}

.importar-indicadores h4 {
  font-size: 20px;
}

.file-drop-area {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px;
  border: 3px dashed #e9ecef;
  border-radius: 3px;
  transition: 0.2s;
  margin: 10px auto;
}

.file-drop-area:hover {
  border-color: #0fafd7;
}

.file-drop-area.active-file {
  border-color: #0fafd7;
}

.fake-btn {
  flex-shrink: 0;
  background-color: #e9ecef;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  padding: 8px 15px;
  margin-right: 10px;
  font-size: 12px;
  text-transform: uppercase;
}

.file-msg {
  font-size: small;
  font-weight: 300;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
}

.file-input {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
  opacity: 0;
}

.importar-indicadores button {
  width: 100%;
  height: 66px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-transform: uppercase;
  border: 1px solid #ccc;
  background: #f1f1f1;
}

.importar-indicadores button i {
  font-size: 20px;
}
</style>
